import CreatorCreateAudioComponent from "./CreatorCreateAudioComponent";
export default CreatorCreateAudioComponent;
